<template>
  <div class="error-message">
    <div class="error-icon">
      <Icon name="alert" />
    </div>
    <span><slot></slot></span>
  </div>
</template>

<script>
import Icon from '@/components/Icon';
export default {
  name: 'ErrorMessage',
  components: { Icon },
};
</script>

<style scoped lang="scss">
.error-message {
  margin-top: 30px;
  color: red;
  display: flex;
  align-content: center;

  > .error-icon {
    display: flex;
    align-items: center;
    > img {
      max-height: 20px;
      margin-right: 5px;
    }
  }
}
</style>
